import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAtlasStore } from '../store/atlasStore';
import { atlasClient } from '../api/atlasClient';
import { RadarArticleCard } from '../components/RadarArticleCard';
import { InlineSvg } from '../components/icons/InlineSvg';
import { AtlasContext, AtlasPosthocTagMap, Dimension } from '../types/atlas';
import { formatContextToken, getContextKey, getContextLabel } from '../utils/context';
import '../styles/radar.css';

// Icons
const RadarSidebarIcon = () => (
  <svg viewBox="0 0 20 20" width="28" height="28" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M4.5127 8.57019C4.60505 8.57019 4.68785 8.62706 4.721 8.71325L4.98404 9.39715C5.05109 9.57146 5.07215 9.62169 5.10097 9.66221C5.12989 9.70288 5.16541 9.73841 5.20608 9.76732C5.24661 9.79614 5.29684 9.81721 5.47115 9.88425L6.15505 10.1473C6.24124 10.1804 6.29811 10.2632 6.29811 10.3556C6.29811 10.4479 6.24124 10.5307 6.15505 10.5639L5.47115 10.8269C5.29684 10.894 5.24661 10.915 5.20608 10.9438C5.16541 10.9728 5.12989 11.0083 5.10097 11.049C5.07215 11.0895 5.05109 11.1397 4.98404 11.314L4.721 11.9979C4.68785 12.0841 4.60505 12.141 4.5127 12.141C4.42036 12.141 4.33755 12.0841 4.3044 11.9979L4.04136 11.314C3.97432 11.1397 3.95325 11.0895 3.92444 11.049C3.89552 11.0083 3.85999 10.9728 3.81933 10.9438C3.7788 10.915 3.72857 10.894 3.55426 10.8269L2.87036 10.5639C2.78417 10.5307 2.72729 10.4479 2.72729 10.3556C2.72729 10.2632 2.78417 10.1804 2.87036 10.1473L3.55426 9.88425C3.72857 9.81721 3.7788 9.79614 3.81933 9.76732C3.85999 9.73841 3.89552 9.70288 3.92444 9.66221C3.95325 9.62169 3.97432 9.57146 4.04136 9.39715L4.3044 8.71325C4.33755 8.62706 4.42036 8.57019 4.5127 8.57019Z" fill="#67E3F9"/>
    <path d="M10.7275 1.85059C10.4878 1.82946 10.2452 1.81836 10 1.81836C5.48131 1.81836 1.81836 5.48131 1.81836 10C1.81836 14.5187 5.48131 18.1816 10 18.1816C14.5187 18.1816 18.1816 14.5187 18.1816 10C18.1816 8.64009 17.8478 7.35887 17.2607 6.23047L18.8564 5.35938C18.195 4.09952 17.2729 2.9983 16.1621 2.12695C18.4977 3.95751 20 6.80247 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C10.3252 0 10.6466 0.0165332 10.9639 0.046875L10.7275 1.85059ZM15.876 1.91016C15.7284 1.80271 15.5773 1.69999 15.4238 1.60059C15.4794 1.63656 15.536 1.67097 15.5908 1.70801L15.876 1.91016Z" fill="#6172F3"/>
    <path d="M15.6562 7.10547C16.107 7.97405 16.3632 8.95721 16.3633 10C16.3632 13.4596 13.5647 16.2742 10.0791 16.3613C10.0239 16.3627 9.96858 16.3633 9.91309 16.3633C9.87274 16.3633 9.83216 16.363 9.79199 16.3623C7.26057 16.3164 5.08641 14.8314 4.07227 12.7021C4.19377 12.7706 4.33041 12.8153 4.47461 12.8252C4.49519 12.8266 4.51624 12.8271 4.53711 12.8271C4.56128 12.8271 4.58555 12.826 4.60938 12.8242C4.96894 12.7969 5.28404 12.5674 5.41504 12.2314L5.63086 11.6787C5.65194 11.731 5.67429 11.7827 5.69727 11.834C6.38897 13.379 7.92642 14.473 9.73145 14.542C9.79159 14.5443 9.85237 14.5459 9.91309 14.5459C9.95278 14.5459 9.99278 14.5449 10.0322 14.5439C12.5217 14.4815 14.5204 12.4709 14.5205 10C14.5205 9.26213 14.3835 8.56422 14.1143 7.94629L15.6562 7.10547ZM9.91309 3.63672C10.1066 3.63673 10.2981 3.64563 10.4873 3.66211L10.249 5.46191C10.2593 5.46247 10.27 5.46324 10.2803 5.46387C10.1988 5.45948 10.1161 5.45731 10.0322 5.45605L9.91309 5.4541C9.84808 5.4541 9.7831 5.45538 9.71875 5.45801C7.78556 5.53714 6.16003 6.79232 5.55664 8.5166C5.53666 8.57372 5.51771 8.63133 5.5 8.68945L5.41504 8.47266C5.28412 8.13687 4.96966 7.90741 4.61035 7.87988L4.53711 7.87695C4.51454 7.87696 4.492 7.87831 4.46973 7.87988C4.13224 7.90385 3.83275 8.10507 3.6875 8.40625L3.65918 8.47266L3.63672 8.53027C4.30934 5.72452 6.86341 3.63673 9.91309 3.63672Z" fill="#6172F3"/>
    <path d="M9.76562 9.1211C9.37709 9.22443 9.09082 9.57893 9.09082 10C9.09083 10.5021 9.49793 10.9092 10 10.9092C10.5021 10.9092 10.9092 10.5021 10.9092 10C10.9092 9.90212 10.8929 9.80807 10.8643 9.71973L12.4678 8.84571C12.3885 8.67661 12.2922 8.51723 12.1816 8.36914C12.5225 8.82438 12.7275 9.38755 12.7275 10C12.7275 11.5062 11.5062 12.7275 10 12.7275C8.49378 12.7275 7.27247 11.5062 7.27246 10C7.27246 8.49377 8.49377 7.27247 10 7.27247C10.0029 7.27247 10.0059 7.27246 10.0088 7.27247L9.76562 9.1211ZM11.4844 7.71387C11.4002 7.65888 11.312 7.61002 11.2217 7.56446C11.2475 7.57741 11.2745 7.58782 11.2998 7.60157L11.4844 7.71387Z" fill="#6172F3"/>
    <path d="M10.0088 7.27247C11.0978 7.27628 12.0341 7.91991 12.4678 8.84571L10.8647 9.72118C10.7469 9.3556 10.4047 9.09085 10 9.09085C9.91891 9.09085 9.84044 9.10118 9.76562 9.1211L10.0088 7.27247ZM10.4883 3.65584C12.7503 3.8275 14.6806 5.18134 15.6649 7.10133L14.0678 7.97313C13.3576 6.55056 11.9245 5.55255 10.249 5.46191L10.4883 3.65584ZM10.965 0.0469971C14.4005 0.375994 17.3256 2.44363 18.8564 5.35938L17.2607 6.23047C16.003 3.81269 13.5757 2.10277 10.7271 1.85186L10.965 0.0469971Z" fill="#CFF9FE"/>
  </svg>
);

const SearchIcon = () => (
  <svg viewBox="0 0 21 20" fill="none">
    <path d="M18 17.5l-3.625-3.625M16.333 9.167a7.167 7.167 0 11-14.333 0 7.167 7.167 0 0114.333 0z" stroke="currentColor" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ChevronDownIcon = () => (
  <svg viewBox="0 0 16 16" fill="none">
    <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

type RadarFilterArticle = {
  latest_version_posthoc_tags?: AtlasPosthocTagMap;
  latest_version_posthoc_related_tags?: AtlasPosthocTagMap;
};

type TagFilterOption = {
  tagFqn: string;
  label: string;
  count: number;
};

type TagFilterDimension = {
  dimensionFqn: string;
  label: string;
  options: TagFilterOption[];
};

const getFqnLeafToken = (fqn: string): string => {
  const suffix = fqn.includes('@') ? fqn.split('@')[1] : fqn;
  return suffix.split('/').pop() || suffix;
};

const formatFqnLabel = (fqn: string): string => formatContextToken(getFqnLeafToken(fqn));

const truncateFilterLabel = (label: string, maxChars: number = 40): string =>
  label.length > maxChars ? `${label.slice(0, maxChars - 1)}…` : label;

const getArticlePosthocTags = (article: RadarFilterArticle): Map<string, Set<string>> => {
  const tagsByDimension = new Map<string, Set<string>>();

  [article.latest_version_posthoc_tags, article.latest_version_posthoc_related_tags].forEach((tagMap) => {
    Object.entries(tagMap || {}).forEach(([dimensionFqn, tagFqns]) => {
      if (!Array.isArray(tagFqns) || tagFqns.length === 0) {
        return;
      }

      const tags = tagsByDimension.get(dimensionFqn) || new Set<string>();
      tagFqns.forEach((tagFqn) => {
        if (tagFqn) {
          tags.add(tagFqn);
        }
      });

      if (tags.size > 0) {
        tagsByDimension.set(dimensionFqn, tags);
      }
    });
  });

  return tagsByDimension;
};

// Sidebar
const RadarSidebar: React.FC<{
  dimensions: Dimension[];
  articleCountByDimension: Record<string, number>;
  activeDimension: string | null;
  onSelect: (fqn: string) => void;
}> = ({ dimensions, articleCountByDimension, activeDimension, onSelect }) => {
  const visibleDimensions = dimensions.filter(
    dim => (articleCountByDimension[dim.fqn] || 0) > 0
  );

  return (
    <nav className="radar-sidebar" aria-label="Radar dimensions">
      <div className="radar-sidebar-header">
        <RadarSidebarIcon />
        <span>Radar</span>
      </div>
      <ul className="radar-sidebar-list">
        {visibleDimensions.map(dim => (
          <li key={dim.fqn}>
            <button
              className={`radar-sidebar-item ${activeDimension === dim.fqn ? 'active' : ''}`}
              onClick={() => onSelect(dim.fqn)}
            >
              <div className="radar-sidebar-icon">
                {dim.icon_url ? (
                  <InlineSvg url={dim.icon_url} />
                ) : (
                  <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
                  </svg>
                )}
              </div>
              <span>{dim.plural_name || dim.name}</span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

// Filter set dropdown
const FilterSetDropdown: React.FC<{
  availableContexts: Array<{ context: AtlasContext; count: number }>;
  selectedContext: AtlasContext | null;
  onSelect: (context: AtlasContext | null) => void;
}> = ({ availableContexts, selectedContext, onSelect }) => {
  const [open, setOpen] = useState(false);

  if (availableContexts.length <= 1) return null;

  const currentLabel = selectedContext ? getContextLabel(selectedContext) : 'All contexts';

  return (
    <div className="radar-filter-dropdown">
      <button className="radar-filter-button" onClick={() => setOpen(!open)} title={currentLabel}>
        <span className="radar-filter-button-label">{truncateFilterLabel(currentLabel)}</span>
        <ChevronDownIcon />
      </button>
      {open && (
        <div className="radar-filter-menu">
          <button
            className={`radar-filter-option ${!selectedContext ? 'selected' : ''}`}
            onClick={() => { onSelect(null); setOpen(false); }}
          >
            All contexts
          </button>
          {availableContexts.map((item, i) => {
            const label = getContextLabel(item.context);
            const isSelected = selectedContext && getContextKey(selectedContext) === getContextKey(item.context);
            return (
              <button
                key={i}
                className={`radar-filter-option ${isSelected ? 'selected' : ''}`}
                onClick={() => { onSelect(item.context); setOpen(false); }}
              >
                {label} ({item.count})
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

const TagFilterDropdown: React.FC<{
  filter: TagFilterDimension;
  selectedTagFqn: string | null;
  onSelect: (dimensionFqn: string, tagFqn: string | null) => void;
}> = ({ filter, selectedTagFqn, onSelect }) => {
  const [open, setOpen] = useState(false);
  const selectedOption = filter.options.find((option) => option.tagFqn === selectedTagFqn) || null;
  const currentLabel = selectedOption ? `${filter.label}: ${selectedOption.label}` : filter.label;

  if (filter.options.length === 0) return null;

  return (
    <div className="radar-filter-dropdown">
      <button className="radar-filter-button" onClick={() => setOpen(!open)} title={currentLabel}>
        <span className="radar-filter-button-label">{truncateFilterLabel(currentLabel)}</span>
        <ChevronDownIcon />
      </button>
      {open && (
        <div className="radar-filter-menu">
          <button
            className={`radar-filter-option ${!selectedTagFqn ? 'selected' : ''}`}
            onClick={() => { onSelect(filter.dimensionFqn, null); setOpen(false); }}
          >
            All {filter.label}
          </button>
          {filter.options.map((option) => (
            <button
              key={option.tagFqn}
              className={`radar-filter-option ${selectedTagFqn === option.tagFqn ? 'selected' : ''}`}
              onClick={() => { onSelect(filter.dimensionFqn, option.tagFqn); setOpen(false); }}
            >
              {option.label} ({option.count})
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

// Skeleton grid
const RadarSkeleton: React.FC = () => (
  <div className="radar-grid">
    {Array.from({ length: 6 }).map((_, i) => (
      <div key={i} className="radar-skeleton-card">
        <div className="radar-skeleton-image" />
        <div className="radar-skeleton-body">
          <div className="radar-skeleton-line title" />
          <div className="radar-skeleton-line" />
          <div className="radar-skeleton-line" />
          <div className="radar-skeleton-line short" />
        </div>
      </div>
    ))}
  </div>
);

// Main view
export const RadarView: React.FC = () => {
  const navigate = useNavigate();
  const {
    dimensions,
    fetchDimensions,
    setCurrentItemsDimension,
    currentItemsDimension,
    dimensionArticles,
    itemElements,
    availableContexts,
    selectedContext,
    setSelectedContext,
    isLoading,
  } = useAtlasStore();

  const [searchQuery, setSearchQuery] = useState('');
  const [articleCountByDimension, setArticleCountByDimension] = useState<Record<string, number>>({});
  const [initialLoadDone, setInitialLoadDone] = useState(false);
  const [selectedTagFilters, setSelectedTagFilters] = useState<Record<string, string>>({});

  // Fetch dimensions and article summaries on mount
  useEffect(() => {
    const init = async () => {
      await fetchDimensions();
      try {
        const summaries = await atlasClient.listAllArticleSummaries();
        const counts: Record<string, number> = {};
        summaries.forEach(s => {
          if (s.dimension_fqn) {
            counts[s.dimension_fqn] = (counts[s.dimension_fqn] || 0) + 1;
          }
        });
        setArticleCountByDimension(counts);
      } catch (e) {
        console.error('Failed to load article summaries:', e);
      }
      setInitialLoadDone(true);
    };
    init();
  }, [fetchDimensions]);

  // Auto-select first dimension with articles once data is available
  useEffect(() => {
    if (!initialLoadDone || currentItemsDimension) return;
    const counts = articleCountByDimension;
    const firstWithArticles = dimensions.find(d => (counts[d.fqn] || 0) > 0);
    if (firstWithArticles) {
      setCurrentItemsDimension(firstWithArticles.fqn);
    }
  }, [initialLoadDone, dimensions, articleCountByDimension, currentItemsDimension, setCurrentItemsDimension]);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!target.closest('.radar-filter-dropdown')) {
        // Close any open dropdown by forcing re-render via state isn't needed -
        // the FilterSetDropdown handles its own state
      }
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  const handleDimensionSelect = (fqn: string) => {
    setSearchQuery('');
    setCurrentItemsDimension(fqn);
  };

  useEffect(() => {
    setSelectedTagFilters({});
  }, [currentItemsDimension]);

  const dimensionNameByFqn = useMemo(() => {
    const map: Record<string, string> = {};
    dimensions.forEach((dimension) => {
      map[dimension.fqn] = dimension.plural_name || dimension.name;
    });
    return map;
  }, [dimensions]);

  const elementNameByFqn = useMemo(() => {
    const map: Record<string, string> = {};
    dimensions.forEach((dimension) => {
      dimension.elements.forEach((element) => {
        map[element.fqn] = element.name;
      });
    });
    return map;
  }, [dimensions]);

  const contextFilteredArticles = useMemo(() => {
    let articles = dimensionArticles;

    if (selectedContext) {
      articles = articles.filter(a => {
        return getContextKey(a.context || null) === getContextKey(selectedContext);
      });
    }

    return articles;
  }, [dimensionArticles, selectedContext]);

  const tagFilterDimensions = useMemo<TagFilterDimension[]>(() => {
    const optionLabelsByDimension = new Map<string, Map<string, string>>();
    const optionCountsByDimension = new Map<string, Map<string, number>>();

    dimensionArticles.forEach((article) => {
      getArticlePosthocTags(article).forEach((tagFqns, dimensionFqn) => {
        const labelMap = optionLabelsByDimension.get(dimensionFqn) || new Map<string, string>();
        tagFqns.forEach((tagFqn) => {
          labelMap.set(tagFqn, elementNameByFqn[tagFqn] || formatFqnLabel(tagFqn));
        });
        optionLabelsByDimension.set(dimensionFqn, labelMap);
      });
    });

    contextFilteredArticles.forEach((article) => {
      getArticlePosthocTags(article).forEach((tagFqns, dimensionFqn) => {
        const countMap = optionCountsByDimension.get(dimensionFqn) || new Map<string, number>();
        tagFqns.forEach((tagFqn) => {
          countMap.set(tagFqn, (countMap.get(tagFqn) || 0) + 1);
        });
        optionCountsByDimension.set(dimensionFqn, countMap);
      });
    });

    return Array.from(optionLabelsByDimension.entries())
      .map(([dimensionFqn, optionMap]) => ({
        dimensionFqn,
        label: dimensionNameByFqn[dimensionFqn] || formatFqnLabel(dimensionFqn),
        options: Array.from(optionMap.entries())
          .map(([tagFqn, label]) => ({
            tagFqn,
            label,
            count: optionCountsByDimension.get(dimensionFqn)?.get(tagFqn) || 0,
          }))
          .sort((a, b) => a.label.localeCompare(b.label)),
      }))
      .sort((a, b) => a.dimensionFqn.localeCompare(b.dimensionFqn));
  }, [contextFilteredArticles, dimensionArticles, dimensionNameByFqn, elementNameByFqn]);

  useEffect(() => {
    const validSelections = new Map(
      tagFilterDimensions.map((filter) => [filter.dimensionFqn, new Set(filter.options.map((option) => option.tagFqn))])
    );

    setSelectedTagFilters((current) => {
      let changed = false;
      const next: Record<string, string> = {};

      Object.entries(current).forEach(([dimensionFqn, tagFqn]) => {
        if (validSelections.get(dimensionFqn)?.has(tagFqn)) {
          next[dimensionFqn] = tagFqn;
        } else {
          changed = true;
        }
      });

      return changed ? next : current;
    });
  }, [tagFilterDimensions]);

  // Filter articles
  const filteredArticles = useMemo(() => {
    let articles = contextFilteredArticles;

    const activeTagFilters = Object.entries(selectedTagFilters);
    if (activeTagFilters.length > 0) {
      articles = articles.filter((article) => {
        const tagsByDimension = getArticlePosthocTags(article);
        return activeTagFilters.every(([dimensionFqn, tagFqn]) => tagsByDimension.get(dimensionFqn)?.has(tagFqn));
      });
    }

    // Filter by search query
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      articles = articles.filter(a =>
        a.name.toLowerCase().includes(q) ||
        (a.summary && a.summary.toLowerCase().includes(q))
      );
    }

    return articles;
  }, [contextFilteredArticles, selectedTagFilters, searchQuery]);

  // Build element description lookup from subject_fqn -> description
  const elementDescriptions = useMemo(() => {
    const map: Record<string, string> = {};
    itemElements.forEach(el => {
      if (el.description) map[el.fqn] = el.description;
    });
    return map;
  }, [itemElements]);

  const currentDim = dimensions.find(d => d.fqn === currentItemsDimension);
  const currentDimensionName = currentDim?.plural_name || currentDim?.name || '';

  const handleCardClick = (articleFqn: string) => {
    const encodedFqn = encodeURIComponent(articleFqn);
    navigate(`/viewer/${encodedFqn}`, {
      state: {
        fromView: 'radar',
        dimensionFqn: currentItemsDimension,
        navContext: {
          section: 'agent' as const,
          path: '/radar',
          hint: 'radar',
          label: 'Radar',
        },
      },
    });
  };

  const handleTagFilterSelect = (dimensionFqn: string, tagFqn: string | null) => {
    setSelectedTagFilters((current) => {
      const next = { ...current };

      if (tagFqn) {
        next[dimensionFqn] = tagFqn;
      } else {
        delete next[dimensionFqn];
      }

      return next;
    });
  };

  const isLoadingContent = isLoading.dimensions || isLoading.itemElements;
  const hasActiveTagFilters = Object.keys(selectedTagFilters).length > 0;

  return (
    <div className="radar-view">
      <div className="main-content overview-mode">
        <div className="radar-layout">
          <RadarSidebar
            dimensions={dimensions}
            articleCountByDimension={articleCountByDimension}
            activeDimension={currentItemsDimension}
            onSelect={handleDimensionSelect}
          />
          <div className="radar-main">
            <div className="radar-header">
              <div className="radar-title-row">
                <h1>{currentDimensionName}</h1>
              </div>
            </div>

            <div className="radar-content">
              <div className="radar-cards-shell">
                <div className="radar-cards-toolbar">
                  <div className="radar-search">
                    <SearchIcon />
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={e => setSearchQuery(e.target.value)}
                      onKeyDown={e => { if (e.key === 'Escape') setSearchQuery(''); }}
                      placeholder="Search titles"
                    />
                  </div>
                  <div className="radar-filter-cluster">
                    <FilterSetDropdown
                      availableContexts={availableContexts}
                      selectedContext={selectedContext}
                      onSelect={setSelectedContext}
                    />
                    {tagFilterDimensions.map((filter) => (
                      <TagFilterDropdown
                        key={filter.dimensionFqn}
                        filter={filter}
                        selectedTagFqn={selectedTagFilters[filter.dimensionFqn] || null}
                        onSelect={handleTagFilterSelect}
                      />
                    ))}
                  </div>
                </div>

                {isLoadingContent ? (
                  <RadarSkeleton />
                ) : filteredArticles.length === 0 ? (
                  <div className="radar-empty">
                    {searchQuery.trim() ? (
                      <>
                        <h3>No matches found</h3>
                        <p>No articles match "{searchQuery}". Try a different search term or press ESC to clear.</p>
                      </>
                    ) : selectedContext || hasActiveTagFilters ? (
                      <>
                        <h3>No articles match the current filters</h3>
                        <p>Adjust the context or post-hoc tag filters to broaden the result set.</p>
                      </>
                    ) : !currentItemsDimension ? (
                      <>
                        <h3>Select a dimension</h3>
                        <p>Choose a dimension from the sidebar to browse articles.</p>
                      </>
                    ) : (
                      <>
                        <h3>No articles available</h3>
                        <p>No articles have been published for this dimension yet.</p>
                      </>
                    )}
                  </div>
                ) : (
                  <div className="radar-grid">
                    {filteredArticles.map(article => (
                      <RadarArticleCard
                        key={article.fqn}
                        title={article.name}
                        description={elementDescriptions[article.subject_fqn] || article.summary}
                        imageId={article.hero_image_id}
                        date={article.date}
                        onClick={() => handleCardClick(article.fqn)}
                      />
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
